import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/edge-fixes.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/analytics/Umami.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/SimpleStorageInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/HeaderMenus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/site/NavItemLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatabaseProvider"] */ "/app/context/DatabaseContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFlagsProvider"] */ "/app/context/SiteFlagsContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"lib/design/fonts.ts\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\"],\"style\":[\"normal\"],\"display\":\"swap\",\"variable\":\"--font-display\",\"fallback\":[\"Georgia\",\"Times New Roman\",\"serif\"]}],\"variableName\":\"displayFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"lib/design/fonts.ts\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\"],\"style\":[\"normal\"],\"display\":\"swap\",\"variable\":\"--font-body\",\"fallback\":[\"system-ui\",\"-apple-system\",\"Segoe UI\",\"Roboto\",\"sans-serif\"]}],\"variableName\":\"bodyFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["EmailCollectorProvider"] */ "/app/providers/EmailCollectorProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/utils/storage/localStoragePatch.js");
